import { Fragment, useMemo, useRef } from 'react';
import { useSelector } from 'react-redux';

import { ReduxService } from 'dashboard-services';

import ColumnSettings from '../ColumnSettings';
import Row from '../Row';

const emptyArray = []
const SymbolContent = ({ ...props }) => {
  const scrollRef = useRef(),
        selectedSymbols = useSelector(state => state.seriesState.creatorState.selectedSymbols) || emptyArray,
        filteredItems = useMemo(() => selectedSymbols.map((item, orgIndex) => ReduxService.updateObject(item, { orgIndex })).filter(s => s.pattern === "true" || s.pattern === undefined), [selectedSymbols])
        
  return (
  <Fragment>
    <div className="ng-office-app__authed__content__basket__body__data__basket__headers ng-office-app__authed__content__basket__body__data__basket__headers--pattern">
      <div className="ng-office-app__authed__content__basket__body__data__basket__headers__header">
        Metrics
      </div>
      <ColumnSettings/>
    </div>
    <div 
        className="ng-office-app__authed__content__basket__body__data__basket__items ng-office-app__authed__content__basket__body__data__basket__items--pattern"
        ref={scrollRef}
    >
      {filteredItems.map((filteredItem, filteredItemIndex) => (
        <Row
            {...filteredItem}
            {...props}
            index={filteredItemIndex}
            isPattern
            key={filteredItemIndex}
            scrollRef={scrollRef}
        />
      ))}

    </div>
  </Fragment>
  )
}

export default SymbolContent;